import React from 'react'

import AbsolutePageTemplate from '../../../components/templates/AbsolutePageTemplate'
import FormLoader from './_load/FormLoader'
import FormReplyLoader from './_load/FormReplyLoader'
import PageContent from './PageContent'
import PageHeader from './PageHeader'

const FormsPdfPage = ({ number, id }) => {
  return (
    <AbsolutePageTemplate>
      <FormLoader id={id}>
        <FormReplyLoader formId={id} number={number}>
          <PageHeader />
          <PageContent />
        </FormReplyLoader>
      </FormLoader>
    </AbsolutePageTemplate>
  )
}

export default FormsPdfPage
